import React, { useEffect } from "react"
import { Box } from "@chakra-ui/react"

import { useMedia } from "@app/hooks/useMedia"
import { useReducedMotion } from "@app/hooks/useReducedMotion"
import { useAutoHideHeader } from "@app/hooks/useAutoHideHeader"
import { useSetHeaderHidden } from "@app/providers/headerVisibility"

type Props = {
  headerRef: any
  children: React.ReactNode
}

const HeaderScrollContainer: React.FC<Props> = ({ headerRef, children }) => {
  const { isMedium } = useMedia()
  const setHeaderHidden = useSetHeaderHidden()
  const reducedMotion = useReducedMotion()

  useAutoHideHeader(headerRef, {
    enabled: !isMedium,
    reducedMotion,
    setHeaderHidden,
  })

  // --header-height drives the desktop sticky cart panel offset (see Cart.tsx).
  useEffect(() => {
    const node = headerRef.current
    if (!node) return
    const write = () => document.documentElement.style.setProperty("--header-height", `${node.clientHeight}px`)
    write()
    const ro = new ResizeObserver(write)
    ro.observe(node)
    return () => ro.disconnect()
  }, [headerRef])

  return (
    <Box as="header" ref={headerRef} bgColor="primary.white" position="sticky" top="0px" willChange="transform" zIndex={900}>
      {children}
    </Box>
  )
}

export default HeaderScrollContainer
